import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Redirect, Navigate, useNavigate } from 'react-router-dom';
import './App.css'
import { store, setStore } from './app/store';

import ComingSoon from './pages/ComingSoon/ComingSoon';
import SetPassword from './pages/SetPassword/SetPassword';
import PhoneVerification from './pages/PhoneVerification/PhoneVerification';
import EmailVerification from './pages/EmailVerification/EmailVerification';
import ConfirmMail from './pages/ConfirmMail/ConfirmMail';
import Maintainance from './pages/Maintainance/Maintainance';
import ForgetPassword from './pages/ForgetPassword/ForgetPassword';
import Error from './pages/Error/Error';

// import Wrapper from './pages/Universal/Wrapper';

function App() {
  const store_data = JSON.parse(store());
  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<Wrapper><SetPassword /></Wrapper>} /> */}
        {/* <Route path="/ComingSoon" element={<ComingSoon />} />
        <Route path="/Maintainance" element={<Maintainance />} />
        <Route path="/Error" element={<Error />} />
        <Route path="/TermsConditions" element={<Wrapper><TermsConditions /></Wrapper>} />
        <Route path="/PrivacyPolicy" element={<Wrapper><PrivacyPolicy /></Wrapper>} />
        <Route path="/ShippingDelivery" element={<Wrapper><ShippingDelivery /></Wrapper>} />
        <Route path="/CancellationRefund" element={<Wrapper><CancellationRefund /></Wrapper>} /> */}
        <Route exact path="/:server_id/:user_type/:username/:reset_token/reset" element={<SetPassword />} />
        <Route exact path="/:server_id/:user_type/:username/:phone_otp/phone-verification" element={<PhoneVerification />} />
        <Route exact path="/:server_id/:user_type/:username/:email_otp/email-verification" element={<EmailVerification />} />
        <Route exact path="/ComingSoon" element={<ConfirmMail />} />
        <Route exact path="/Success" element={<ConfirmMail />} />
        <Route path="/Error" element={<Error />} />
        <Route exact path="/Maintainance" element={<Maintainance />} />
        <Route exact path="/forget" element={<ForgetPassword />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
}

export default App;